import { useState } from 'react'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'

import { get } from '@/utils/storage/adapters/localStorageAdapter'

import { Logo } from '../Logo'

import { LocalizationSection } from './LocalizationSection'
import { ProfileSection } from './ProfileSection'

export const Header = () => {
  const theme = useTheme()
  const [isLoggedIn] = useState<boolean>(!!get('token'))

  return (
    <>
      <Box
        sx={{
          width: 300,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto',
          },
        }}
      >
        <Box component={'span'} sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          {isLoggedIn && <Logo />}
        </Box>
      </Box>

      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'end', alignItems: 'center' }}>
        <Box sx={{ display: { xs: 'block', sm: 'block' }, marginRight: '10px' }}>
          <LocalizationSection />
        </Box>
        {isLoggedIn && <ProfileSection />}
      </Box>
    </>
  )
}
